import { z } from 'zod';

const positiveNumber = (message: string) =>
	z
		.string()
		.min(1, message)
		.refine((value) => Number.isFinite(Number(value)) && Number(value) > 0, message);

export const MixtureSettingsSchema = z.object({
	vbox: positiveNumber('Volume da caixa deve ser maior que 0.'),
	totalInjectionTime: positiveNumber('Tempo de injeção deve ser maior que 0.'),
	totalOperationTime: positiveNumber('Tempo de operação deve ser maior que 0.'),
	cemMax: positiveNumber('Concentração máxima deve ser maior que 0.'),
	desiredEventsPerMonth: z.string().refine((value) => {
		if (!value) return true;
		const events = Number(value);
		return Number.isInteger(events) && events >= 1 && events <= 12;
	}, 'Informe um número inteiro entre 1 e 12.'),
});

export const MixtureDraftSchema = z.object({
	date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Informe a data da mistura.'),
	products: z
		.array(
			z.object({
				productKey: z.string().min(1, 'Selecione o produto.'),
				dose: positiveNumber('A dose deve ser maior que 0.'),
			})
		)
		.min(1, 'Adicione ao menos um produto.'),
});
